import {inject, Injectable, signal, PLATFORM_ID, DOCUMENT} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';

/**
 * Тёмная тема сайта: data-theme="dark" на <html>.
 * Выбор сохраняется в localStorage; раннее применение до загрузки
 * Angular — inline-скрипт в index.html (без вспышки светлой темы).
 */
@Injectable({
  providedIn: 'root'
})
export class ThemeService {

  static readonly storageKey = 'site-theme';

  readonly isDark = signal(false);

  private readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID));
  private readonly document = inject(DOCUMENT);

  /** Синхронизирует состояние с атрибутом, выставленным ранним скриптом. */
  init(): void {
    if (!this.isBrowser) return;
    this.isDark.set(this.document.documentElement.dataset['theme'] === 'dark');
  }

  toggle(): void {
    const dark = !this.isDark();
    this.isDark.set(dark);
    if (!this.isBrowser) return;

    if (dark) {
      this.document.documentElement.dataset['theme'] = 'dark';
    } else {
      delete this.document.documentElement.dataset['theme'];
    }
    localStorage.setItem(ThemeService.storageKey, dark ? 'dark' : 'light');
  }
}
